/**
 * @voltxampere/ui — 1N5817 Schottky diode variant (Sprint 38-4)
 *
 * Reference: onsemi 1N5817 datasheet (DO-41 axial, 20 V / 1 A
 * Schottky rectifier).
 *   V_F ≈ 0.32 V @ I_F = 1 A     (low forward drop — Schottky's edge)
 *   I_R ≈ 5e-7 A                 (datasheet leakage @ V_R = 20 V)
 *
 * Schottky V_F achieved by elevated saturationCurrent (Si Shockley
 * Is ≈ 1e-14 vs Schottky ≈ 4e-6 A) so the existing diode stamp's
 * exponential I-V characteristic delivers the sub-0.4 V threshold
 * without a new engine type.
 *
 * Engine zero-diff invariant honored — variant maps to canonical
 * `diode` engine stamp (Sprint 5).
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { diode } from "../diode.js";
export const schottky1n5817 = {
    id: "1n5817",
    nameTr: "1N5817 (Schottky 1A, DO41)",
    nameEn: "1N5817 (1A Schottky, DO41)",
    shortcut: "D",
    category: "active",
    viewBox: diode.viewBox,
    terminals: diode.terminals,
    defaultLabel: "D",
    defaultValue: "1N5817",
    schemaType: "diode",
    defaultParams: { saturationCurrent: 4.2e-6, ideality: 1.0 },
    renderSVG: () => diode.renderSVG(),
};
//# sourceMappingURL=schottky-1n5817.js.map